import { userDetails } from '@Containers/UserDetails/UserDetailsSelectors';

// eslint-disable-next-line import/prefer-default-export
export function maintainMessage(state) {
  return userDetails(state).get('maintainMessage');
}
